export async function getTotalFormDataSize(
  formData: FormData[],
): Promise<number> {
  const bytesArray = await Promise.all(
    formData.map(async (data) => {
      const bytes = await new Response(data).arrayBuffer();
      return bytes.byteLength;
    }),
  );
  return bytesArray.reduce((acc, size) => acc + size, 0);
}
